
<main *ngIf="bShowTemplate" class="">

    <!-- عنوان اصلی صفحه -->

    <!-- فرم ثبت نام و ورود -->

    <article class="header-taxilon px-3 mb-5 w-100 h-100 p-2">

        <div class="background-image position-relative w-100 h-100">

            <img width="100%" src="../../assets/imgs/partner-bg.png" alt="همکاران تاکسی لون">

            <div class="header-layer w-100 h-100">

                <div class="signUp-container px-4 pb-3">

                    <h2 class="text-center border-bottom border-3">

                        <ng-container *ngIf="!mdl_Login.get('bOTP')?.value;else title_OTP">

                            {{ mdl_Login.get('bRegister')?.value ? 'ثبت نام همکاران' : 'ورود به حساب کاربری' }}

                        </ng-container>

                        <ng-template #title_OTP>

                            تایید کد 

                        </ng-template>

                    </h2>

                    <div [formGroup]="mdl_Login" class="row gx-0 gy-3">

                        <ng-container *ngIf="!mdl_Login.get('bOTP')?.value;else mdl_OTP">

                            <!-- شماره موبایل -->

                            <div class="col-12 form-group has-icon">

                                <span class="form-control-icon">
        
                                    <mat-icon class="mat-18">phone_iphone</mat-icon>
        
                                </span>
        
                                <input class="w-100 form-control" #strMobile

                                    autocomplete="mobile"

                                    [ngStyle]="{ direction: strMobile.value.trim() == '' ? 'rtl' : 'ltr' }"

                                    [placeholder]="strMobile.value.trim() == '' ? ' * شماره موبایل ' : '' "

                                    (input)="filterNumericInput($event)" inputmode="numeric"
                                    
                                    maxlength="11" formControlName="strMobile" type="text">
        
                            </div>

                            <!-- نام و نام خانوادگی -->

                            <ng-container *ngIf="mdl_Login.get('bRegister')?.value">

                                <div class="col-12 form-group has-icon">

                                    <span class="form-control-icon">
            
                                        <mat-icon class="mat-18">badge</mat-icon>
            
                                    </span>
            
                                    <input class="w-100 form-control" 
                                    
                                        placeholder="* نام و نام خانوادگی"

                                        formControlName="strFullName"
                                        
                                        type="text" autocomplete="cc-family-name">
            
                                </div>

                            </ng-container>

                            <!-- رمز عبور -->

                            <div class="col-12 form-group has-icon">

                                <span class="form-control-icon">

                                    <mat-icon class="mat-18"> lock </mat-icon>

                                </span>

                                <input type="password" class="w-100 form-control" formControlName="strUserPassword"
                                
                                    placeholder="* رمز عبور" autocomplete="new-password">

                            </div>

                            <!-- فیلد های ثبت نام -->

                            <ng-container *ngIf="mdl_Login.get('bRegister')?.value">

                                <!-- تکرار رمز عبور -->

                                <div class="col-12 form-group has-icon">

                                    <span class="form-control-icon">

                                        <mat-icon class="mat-18"> lock </mat-icon>

                                    </span>

                                    <input type="password" class="w-100 form-control" formControlName="_strUserPassword"
                                    
                                        placeholder="* تکرار رمز عبور" autocomplete="new-password">

                                </div>

                                <!-- آدرس -->

                                <div class="col-12 form-group has-icon">

                                    <span class="form-control-icon">
            
                                        <mat-icon class="mat-18">home_app_logo</mat-icon>
            
                                    </span>
            
                                    <input class="w-100 form-control" placeholder=" آدرس" formControlName="strAddress"
                                    
                                        type="text" autocomplete="address-level1">
            
                                </div>

                                <!-- نام هتل/شرکت  -->

                                <div class="col-12 form-group has-icon">

                                    <span class="form-control-icon">
            
                                        <mat-icon class="mat-18">apartment</mat-icon>
            
                                    </span>
            
                                    <input class="w-100 form-control" placeholder=" نام هتل/شرکت " formControlName="strCompanyName"
                                    
                                        type="text" autocomplete="cc-additional-name">
            
                                </div>

                            </ng-container>

                        </ng-container>

                        <ng-template #mdl_OTP>

                            <p class="hint-otp my-2 text-dark"> 

                                کد ارسال شده به شماره 

                                <span> {{ mdl_Login.get('strMobile')?.value | faNum }} </span>

                                را وارد کنید.
                                
                            </p>

                            <div class="otp-input">

                                <input type="number" (input)="enforceMaxLength($event,'1')" id="input1" required>

                                <input type="number" (input)="enforceMaxLength($event,'2')" id="input2" required>

                                <input type="number" (input)="enforceMaxLength($event,'3')" id="input3" required>

                                <input type="number" (input)="enforceMaxLength($event,'4')" id="input4" required>

                            </div>

                        </ng-template>

                        <!-- تایید -->

                        <div class="col-12 pt-2">

                            <button type="button" class="btn btn-primary w-100" (click)="submit_form()"> 

                                تایید

                            </button>

                        </div>

                        <!-- حساب کاربری دارید؟ -->

                        <div class="row gx-0 gy-0 pt-2 justify-content-center col-12 mt-3 border-top border-3">

                            <!-- حساب کاربری دارید ؟ -->

                            <div class="col-5 text-center py-2 pointer" (click)="mdl_Switch()">

                                <ng-container *ngIf="!mdl_Login.get('bOTP')?.value;else back_OTP">

                                    <span class="text-dark">

                                        {{ mdl_Login.get('bRegister')?.value ? 'حساب کاربری دارید ؟' : 'ثبت نام نکرده اید؟' }}


                                    </span>

                                </ng-container>

                                <ng-template #back_OTP>

                                    <span class="text-dark"> بازگشت </span>

                                </ng-template>

                            </div>

                            <div class="col-auto text-center py-2">

                                <span class="text-dark">|</span>

                            </div>

                            <div class="col-5 text-center py-2 pointer" (click)="mdl_Login.get('bRegister')?.value ? openAdd() : reset_Password() ">

                                <span class="text-dark">

                                    {{ mdl_Login.get('bRegister')?.value || mdl_Login.get('bOTP')?.value ? 'قوانین و مقررات' : 'فراموشی رمز عبور' }}

                                </span>

                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </div>
        
        <div class="my-5 d-flex flex-column justify-content-center align-items-center">

            <div class="img-container text-center">

                <img width="128px" src="../../assets/imgs/coin.png" alt="خدمات حمل‌ونقل مسافران خود را هوشمند کنید و درآمد بیشتری کسب کنید">
    
            </div>

            <h2 class="fw-bold mt-3" style="font-size: 25px;line-height: 40px;"> خدمات حمل‌ونقل مسافران خود را هوشمند کنید و درآمد بیشتری کسب کنید! </h2>

            <div class="title-header w-100" style="padding: 0 120px;">
    
                <p class="m-0 fw- text-muted text-center" style="font-size:16px;line-height: 40px;">
                    
                    تاکسی لون یک سامانه نوین و هوشمند برای مدیریت و ارائه خدمات حمل‌ونقل شهری است که به شما این امکان را می‌دهد تا به جای استفاده از روش‌های سنتی برای اعزام خودرو، سفرهای خود را به صورت آنلاین ثبت و مدیریت کنید. این پلتفرم با بهره‌گیری از فناوری‌های پیشرفته و طراحی کاربرپسند، تجربه‌ای راحت و سریع را برای مسافران و رانندگان به ارمغان می‌آورد.            
                    
                </p>
    
            </div>

        </div>

    </article>

    <!-- چرا باید از تاکسی لون استفاده کنید؟ -->

    <article class="d-flex flex-column align-items-center px-3 pt-3 w-100 h-100" style="background: #f5f5f5;">

        <h2 class="fw-bold mt-3" style="line-height: 40px;">چرا باید از تاکسی لون استفاده کنید؟</h2>

        <div class="container w-100 row gx-0 gy-5 mb-5 p-4">

            <!-- پنل مدیریتی اختصاصی -->

            <div class="col-12 col-md-4 px-2" style="height: 90px;">

                <div class="row gx-0 gy-0 bg-white w-100 h-100">

                    <div class="col-md-auto px-3 d-flex align-items-center justify-content-center border-start border-2">

                        <img src="../../assets/imgs/panel.png" alt="">
    
                    </div>
    
                    <div class="col-md-9 d-flex flex-column justify-content-center  px-3 py-2">
    
                        <strong class="mb-1"> پنل مدیریتی اختصاصی </strong>
    
                        <small class="fw-bold text-muted"> پنلی هوشمند برای ثبت، مدیریت سفرها، گزارشات مالی و برنامه‌ریزی بهتر. </small>
    
                    </div>

                </div>
                


            </div>

            <!-- 7 روز هفته 24 ساعته -->

            <div class="col-12 col-md-4 px-2" style="height: 90px;">

                <div class="row gx-0 gy-0 bg-white w-100 h-100">

                    <div class="col-md-auto px-3 d-flex align-items-center justify-content-center border-start border-2">

                        <img src="../../assets/imgs/24-hours-support.png" alt="">
    
                    </div>
    
                    <div class="col-md-9 d-flex flex-column justify-content-center  px-3 py-2">
    
                        <strong class="mb-1"> ۷ روز ﻫﻔﺘﻪ، ۲۴ ﺳﺎﻋﺘﻪ </strong>
    
                        <small class="fw-bold text-muted">  تیم پشتیبانی ما در تمامی مراحل ثبت و اجرای سفر همراه شماست. </small>
    
                    </div>

                </div>
                


            </div>
            
            <!-- افزایش رضایت مسافران -->

            <div class="col-12 col-md-4 px-2" style="height: 90px;">

                <div class="row gx-0 gy-0 bg-white w-100 h-100">

                    <div class="col-md-auto px-3 d-flex align-items-center justify-content-center border-start border-2">

                        <img src="../../assets/imgs/satisfaction.png" alt="">
    
                    </div>
    
                    <div class="col-md-9 d-flex flex-column justify-content-center  px-3 py-2">
    
                        <strong class="mb-1"> افزایش رضایت مسافران </strong>
    
                        <small class="fw-bold text-muted"> مسافران شما تجربه‌ای سریع، راحت و مطمئن خواهند داشت. </small>
    
                    </div>

                </div>
                


            </div>
            
            <!-- تنظیم تعرفه‌های متنوع -->

            <div class="col-12 col-md-4 px-2" style="height: 90px;">

                <div class="row gx-0 gy-0 bg-white w-100 h-100">

                    <div class="col-md-auto px-3 d-flex align-items-center justify-content-center border-start border-2">

                        <img src="../../assets/imgs/taxes.png" alt="">
    
                    </div>
    
                    <div class="col-md-9 d-flex flex-column justify-content-center  px-3 py-2">
    
                        <strong class="mb-1"> تنظیم تعرفه‌های متنوع </strong>
    
                        <small class="fw-bold text-muted"> با قابلیت تنظیم نرخ‌ها، بهترین تجربه را برای مسافران و رانندگان ارائه دهید. </small>
    
                    </div>

                </div>
                


            </div>
            
            <!-- سیستم امتیازدهی -->

            <div class="col-12 col-md-4 px-2" style="height: 90px;">

                <div class="row gx-0 gy-0 bg-white w-100 h-100">

                    <div class="col-md-auto px-3 d-flex align-items-center justify-content-center border-start border-2">

                        <img src="../../assets/imgs/voting-box.png" alt="">
    
                    </div>
    
                    <div class="col-md-9 d-flex flex-column justify-content-center  px-3 py-2">
    
                        <strong class="mb-1"> سیستم امتیازدهی </strong>
    
                        <small class="fw-bold text-muted"> با نظرات مسافران و رانندگان، کیفیت خدمات خود را بهبود بخشید. </small>
    
                    </div>

                </div>
                


            </div>
            
            <!-- تاریخچه سفره -->

            <div class="col-12 col-md-4 px-2" style="height: 90px;">

                <div class="row gx-0 gy-0 bg-white w-100 h-100">

                    <div class="col-md-auto px-3 d-flex align-items-center justify-content-center border-start border-2">

                        <img src="../../assets/imgs/document.png" alt="">
    
                    </div>
    
                    <div class="col-md-9 d-flex flex-column justify-content-center  px-3 py-2">
    
                        <strong class="mb-1"> تاریخچه سفره </strong>
    
                        <small class="fw-bold text-muted"> تمامی اطلاعات مربوط به سفرها، به صورت دقیق ذخیره و قابل دسترسی است. </small>
    
                    </div>

                </div>
                


            </div>

        </div>

    </article>

    <!-- چگونه کار می‌کند؟ -->

    <article class="how-works my-5 d-flex flex-column align-items-center">

        <h2 class="fw-bold mt-3"> چگونه کار می‌کند؟ </h2>

        <div class="container w-100 row gx-0 gy-4 p-4">

            <!-- ثبت نام در تاکسی لون -->

            <div class="col-12 col-md-6 px-2" style="height: 90px;">

                <div class="row gx-0 gy-0 bg-gray w-100 h-100">

                    <div class="col-md-auto px-3 d-flex align-items-center justify-content-center border-start border-2 border-white">

                        <img src="../../assets/imgs/one.png" alt="">
    
                    </div>
    
                    <div class="col-md-9 d-flex flex-column justify-content-center  px-3 py-2">
    
                        <strong class="mb-1"> ثبت نام در تاکسی لون </strong>
    
                        <small class="fw-bold text-muted"> یک حساب کاربری برای آژانس، هتل یا مجموعه خود ایجاد کنید. </small>
    
                    </div>

                </div>
                


            </div>

            <!-- ثبت سفرهای مسافران -->

            <div class="col-12 col-md-6 px-2" style="height: 90px;">

                <div class="row gx-0 gy-0 bg-gray w-100 h-100">

                    <div class="col-md-auto px-3 d-flex align-items-center justify-content-center border-start border-2 border-white">

                        <img src="../../assets/imgs/two.png" alt="">
    
                    </div>
    
                    <div class="col-md-9 d-flex flex-column justify-content-center  px-3 py-2">
    
                        <strong class="mb-1"> ثبت سفرهای مسافران </strong>
    
                        <small class="fw-bold text-muted"> اطلاعات سفر را در پنل خود وارد کنید (مبدأ، مقصد، زمان و...). </small>
    
                    </div>

                </div>
                


            </div>

            <!-- اعزام خودرو توسط تاکسی لون -->

            <div class="col-12 col-md-6 px-2" style="height: 90px;">

                <div class="row gx-0 gy-0 bg-gray w-100 h-100">

                    <div class="col-md-auto px-3 d-flex align-items-center justify-content-center border-start border-2 border-white">

                        <img src="../../assets/imgs/three.png" alt="">
    
                    </div>
    
                    <div class="col-md-9 d-flex flex-column justify-content-center  px-3 py-2">
    
                        <strong class="mb-1"> اعزام خودرو توسط تاکسی لون </strong>
    
                        <small class="fw-bold text-muted"> خودرو مناسب برای سفر، از طریق شبکه رانندگان تاکسی لون تأمین می‌شود.  </small>
    
                    </div>

                </div>
                


            </div>

            <!-- دریافت کمیسیون -->

            <div class="col-12 col-md-6 px-2" style="height: 90px;">

                <div class="row gx-0 gy-0 bg-gray w-100 h-100">

                    <div class="col-md-auto px-3 d-flex align-items-center justify-content-center border-start border-2 border-white">

                        <img src="../../assets/imgs/four.png" alt="">
    
                    </div>
    
                    <div class="col-md-9 d-flex flex-column justify-content-center  px-3 py-2">
    
                        <strong class="mb-1"> دریافت کمیسیون </strong>
    
                        <small class="fw-bold text-muted"> پس از انجام هر سفر، کمیسیون شما به حساب کاربری‌تان واریز می‌شود. </small>
    
                    </div>

                </div>
                


            </div>

        </div>

    </article>

    <!-- چرا تاکسی لون -->

    <article class="d-flex flex-column align-items-center px-3 pt-3 w-100 h-100" style="background: #f5f5f5;">

        <h2 class="fw-bold mt-3" style="line-height: 40px;">چرا تاکسی لون؟</h2>

        <div class="container w-100 row gx-0 gy-4 mb-5 p-4">

            <!-- جایگزین هوشمند برای روش‌های سنتی -->

            <div class="col-12 col-md-6 px-2" style="height: 90px;">

                <div class="row gx-0 gy-0 bg-white w-100 h-100">

                    <div class="col-md-auto px-3 d-flex align-items-center justify-content-center border-start border-2">

                        <img src="../../assets/imgs/smart.png" alt="">
    
                    </div>
    
                    <div class="col-md-9 d-flex flex-column justify-content-center  px-3 py-2">
    
                        <strong class="mb-1"> جایگزین هوشمند برای روش‌های سنتی </strong>
    
                        <small class="fw-bold text-muted"> دیگر نیازی نیست زمان و انرژی زیادی برای هماهنگی خودروها صرف کنید. </small>
    
                    </div>

                </div>
                
            </div>

            <!-- شفافیت در درآمدها -->

            <div class="col-12 col-md-6 px-2" style="height: 90px;">

                <div class="row gx-0 gy-0 bg-white w-100 h-100">

                    <div class="col-md-auto px-3 d-flex align-items-center justify-content-center border-start border-2">

                        <img src="../../assets/imgs/transparency.png" alt="">
    
                    </div>
    
                    <div class="col-md-9 d-flex flex-column justify-content-center  px-3 py-2">
    
                        <strong class="mb-1"> شفافیت در درآمدها </strong>
    
                        <small class="fw-bold text-muted">  تمامی کمیسیون‌ها به صورت شفاف و منظم گزارش می‌شود. </small>
    
                    </div>

                </div>
                


            </div>
            
            <!-- ارتقاء سطح خدمات شما -->

            <div class="col-12 col-md-6 px-2" style="height: 90px;">

                <div class="row gx-0 gy-0 bg-white w-100 h-100">

                    <div class="col-md-auto px-3 d-flex align-items-center justify-content-center border-start border-2">

                        <img src="../../assets/imgs/start.png" alt="">
    
                    </div>
    
                    <div class="col-md-9 d-flex flex-column justify-content-center  px-3 py-2">
    
                        <strong class="mb-1"> ارتقاء سطح خدمات شما </strong>
    
                        <small class="fw-bold text-muted"> با استفاده از پلتفرم تاکسی لون، کیفیت خدمات خود را برای مسافرانتان افزایش دهید. </small>
    
                    </div>

                </div>
                


            </div>
            
            <!-- دسترسی آسان به آمار و گزارش‌ها -->

            <div class="col-12 col-md-6 px-2" style="height: 90px;">

                <div class="row gx-0 gy-0 bg-white w-100 h-100">

                    <div class="col-md-auto px-3 d-flex align-items-center justify-content-center border-start border-2">

                        <img src="../../assets/imgs/analysis.png" alt="">
    
                    </div>
    
                    <div class="col-md-9 d-flex flex-column justify-content-center  px-3 py-2">
    
                        <strong class="mb-1"> دسترسی آسان به آمار و گزارش‌ها </strong>
    
                        <small class="fw-bold text-muted"> به تمام اطلاعات مورد نیازتان در قالب گزارش‌های دقیق و لحظه‌ای دسترسی دارید. </small>
    
                    </div>

                </div>
                


            </div>

        </div>

    </article>

    <!-- سوالات رایج -->

    <article dir="rtl" class="faq-taxilon container p-2 my-5" >

        <div class="accordion" id="accordionExample">

            <div class="accordion-item">

              <h1 class="accordion-header" id="headingOne">

                <button class="accordion-button fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">

                    آیا استفاده از پنل تاکسی لون هزینه دارد؟

                </button>

              </h1>

              <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">

                <div class="accordion-body">

                    خیر، ثبت‌نام و استفاده از پنل کاملاً رایگان است. شما فقط از سفرهایی که ثبت می‌کنید کمیسیون دریافت می‌کنید.

                </div>

              </div>

            </div>

            <div class="accordion-item">
              <h2 class="accordion-header" id="headingTwo">
                <button class="accordion-button fw-bold collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                    کمیسیون به چه صورتی محاسبه می‌شود؟
                </button>
              </h2>
              <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                <div class="accordion-body">
                    درصدی از هزینه هر سفر به حساب شما تعلق می‌گیرد و گزارش آن در پنل شما نمایش داده می‌شود.
                </div>
              </div>
            </div>

            <div class="accordion-item">
              <h2 class="accordion-header" id="headingThree">
                <button class="accordion-button fw-bold collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                    آیا مسافران از کیفیت خدمات راضی خواهند بود؟
                </button>
              </h2>
              <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                <div class="accordion-body">
                    بله، رانندگان تاکسی لون حرفه‌ای هستند و خودروها کاملاً استاندارد و ایمن هستند.

                </div>
              </div>
            </div>

            <div class="accordion-item">
              <h2 class="accordion-header" id="headingFour">
                <button class="accordion-button fw-bold collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                    چگونه مطمئن شوم خودروها به موقع اعزام می‌شوند؟
                </button>
              </h2>
              <div id="collapseFour" class="accordion-collapse collapse" aria-labelledby="headingFour" data-bs-parent="#accordionExample">
                <div class="accordion-body">
                    سیستم ما به صورت خودکار نزدیک‌ترین راننده موجود را انتخاب و هماهنگی‌ها را انجام می‌دهد.
                </div>
              </div>
            </div>

        </div>

    </article>

</main>

<!--  -->

<app-footer></app-footer>